import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedPage } from "../protected-page/ProtectedPage";
import { AppFrame } from "@vetty/internal-ui";
import { SidebarNav, AppHeader } from "@/components";
import { AppNavBridge } from "../app-nav-bridge/AppNavBridge";
import { NavigationLoadingProvider } from "@/contexts/NavigationLoadingContext";
import { usePathname } from "@/lib/router-navigation";

const PUBLIC_PATHS = ["/unauthorized"];

const isOauthPath = (pathname: string) => pathname.startsWith("/oauth/");

/**
 * OAuth authorize/desktop-return stay outside the admin chrome so desktop
 * callers can complete central OIDC continuation without the sidebar shell.
 */
export const AppShell = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();
  const isPublic = PUBLIC_PATHS.includes(pathname) || isOauthPath(pathname);

  if (isPublic) {
    return <AuthProvider>{children}</AuthProvider>;
  }

  return (
    <AuthProvider>
      <ProtectedPage requiredRoles={["super_admin", "admin"]}>
        <NavigationLoadingProvider>
          <AppNavBridge>
            <AppFrame sidebar={<SidebarNav />} header={<AppHeader />}>
              {children}
            </AppFrame>
          </AppNavBridge>
        </NavigationLoadingProvider>
      </ProtectedPage>
    </AuthProvider>
  );
};
